import { render } from "./CreateFacture.vue?vue&type=template&id=66dc7030"
import script from "./CreateFacture.vue?vue&type=script&lang=js"
export * from "./CreateFacture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__